/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Empty_DescriptionInputs */

const en_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const de_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const fr_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const es_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const it_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const nl_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const pl_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const fi_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const da_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

const sv_portal_scanner_empty_description = /** @type {(inputs: Portal_Scanner_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click "Scan All Boards" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time.`)
};

/**
* | output |
* | --- |
* | "Click \"Scan All Boards\" to fetch jobs from all enabled Greenhouse companies, or click individual company cards to scan one at a time." |
*
* @param {Portal_Scanner_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_empty_description = /** @type {((inputs?: Portal_Scanner_Empty_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Empty_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_empty_description(inputs)
	if (locale === "fr") return fr_portal_scanner_empty_description(inputs)
	if (locale === "es") return es_portal_scanner_empty_description(inputs)
	if (locale === "it") return it_portal_scanner_empty_description(inputs)
	if (locale === "nl") return nl_portal_scanner_empty_description(inputs)
	if (locale === "pl") return pl_portal_scanner_empty_description(inputs)
	if (locale === "fi") return fi_portal_scanner_empty_description(inputs)
	if (locale === "da") return da_portal_scanner_empty_description(inputs)
	if (locale === "sv") return sv_portal_scanner_empty_description(inputs)
	return en_portal_scanner_empty_description(inputs)
});